import { computed, defineComponent, ref } from '@nuxtjs/composition-api';
import EntryCompareImage from './EntryCompareImage';
import { calculateRatio, getImage, getImageResponsiveAttributes, getImageUrl } from '~/modules/common/utils/imageUtils';
import { useDevice } from '~/composables/useDevice';
import { OImage } from '~/modules/common/components/ui';

/**
 * Returns img with padding bottom div for aspect ratio
 * @info vue 3 fragment ile jsx yerine vue ile yazilabilir
 */
export default defineComponent({
  functional: true,
  props: {
    entry: {
      type: Object,
      required: true,
    },
    useExtra: {
      type: Boolean,
      default: false,
    },
    showOriginal: {
      type: Boolean,
      default: false,
    },
  },
  components: { EntryCompareImage, OImage },
  render(h, ctx) {
    const { props } = ctx;
    const { isMobile } = useDevice();
    let mobileWidth = 620;
    if (process.client) {
      mobileWidth = window.innerWidth - 20;
      mobileWidth = mobileWidth - (mobileWidth % 50) + 50;
    }
    const width = ref(isMobile.value ? mobileWidth : 635);
    const entryImageUrl = (imageObj, format) => getImageUrl(imageObj, { width: width.value, format });
    const entryImage = getImage(props.entry.image);
    // question result olan entry'ler lazy load olmasin. entrylerde display:none olduğu için yüklenmiyor olabilir veya nuxt/image bug'ı olabilir. örnek haber 441808. sonucu göster butonuna tıkla
    const hasQuestionResult = Boolean(props.entry?.metadata?.question_result);

    let ratio = null;
    if (!entryImage) ratio = null;
    else ratio = calculateRatio(entryImage.width, entryImage.height);

    const hasGoto = computed(() => props.entry.metadata?.goto);

    const isCompareImage = computed(() => props.entry.metadata?.extra_media === 'compare');
    const isGif = computed(() => props.entry.image?.resolutions?.standard?.format === 'gif');

    const alt = props.entry.metadata?.alt || props.entry.title;

    const {
      src: entryImageSrc,
      srcset: entryImageSrcset,
      sizes: entryImageSizes,
    } = getImageResponsiveAttributes(props.useExtra ? props.entry.metadata.extraImages[0] : props.entry.image, {});

    const rawImageSizes = props.entry.image.resolutions.raw;
    const imageElement = props.showOriginal
      ? [
          <OImage
            loading={'lazy'}
            src={getImageUrl(props.entry.image, { raw: true })}
            width={rawImageSizes.width}
            height={rawImageSizes.height}
            alt={alt}
          />,
        ]
      : [
          isCompareImage.value ? (
            <EntryCompareImage
              key={isMobile.value ? 'mobile' : 'desktop'}
              leftImage={entryImageUrl(props.entry.image)}
              rightImage={entryImageUrl(props.entry.metadata.extraImages[0])}
            />
          ) : isGif.value ? (
            <div class="absolute inset-0 h-auto w-full">
              <figure>
                <video autoPlay loop muted playsInline class="sm:w-full">
                  <source type="video/webm" src={entryImageUrl(props.entry.image, 'webm')} />
                  <source type="video/mp4" src={entryImageUrl(props.entry.image, 'mp4')} />
                  {/* <img src={entryImageUrl(props.entry.image, 'gif')} /> */}
                </video>
              </figure>
            </div>
          ) : (
            <OImage
              class="absolute inset-0 h-auto w-full"
              loading={!hasQuestionResult ? 'lazy' : undefined}
              src={entryImageSrc}
              srcset={entryImageSrcset}
              sizes={entryImageSizes}
              alt={alt}
            />
          ),
          <div style={{ paddingTop: ratio }}></div>,
        ];

    if (hasGoto.value) {
      return (
        <a href={props.entry.metadata?.goto} target="_blank" rel="nofollow" data-trckimg="https://t.oned.io/onedio-inline-link.img">
          {imageElement}
        </a>
      );
    }

    return imageElement;
  },
});
